// navigation-new/client.js
import { CLICK, SCROLL } from '../element/shared/enums/events.js';
import { height } from '../element/shared/utils/dont-need-lodash.js';
import { EventPubSub } from '../element/public/src/utils/pubSub.js';

function toggleSearch() {
  const $navigation = document.querySelector('header.navigation');
  if ($navigation) {
    $navigation.classList.toggle('search-open');
    $navigation.querySelector('input.search-field').focus();
  }
}

function toggleMenu() {
  const $navigation = document.querySelector('header.navigation');
  if ($navigation) {
    $navigation.classList.toggle('menu-open');
  }
}

function isElementInView(element, fullyInView, offset) {
  if (!offset) {
    offset = 0;
  }
  var pageTop = window.pageYOffset;
  var pageBottom = pageTop + Math.max(document.documentElement.clientHeight || 0, innerHeight || 0);
  var elementTop = element.getBoundingClientRect().top;
  var elementBottom = elementTop + height(element) + offset;

  if (fullyInView === true) {
      return ((pageTop < elementTop) && (pageBottom > elementBottom));
  }
  else {
      return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
  }
}

export default function () {
  // Handle clicks on the UI.
    EventPubSub.subscribe(CLICK, (e) => {
    const {event, $target, options} = e;
    const navigation = document.querySelector('header.navigation');
    const $navigation = $target.closest('header.navigation');
    const $navFooter = document.querySelector('.navigation .menu-footer');
    if ($navigation) {
      const $button = $target.closest('button');
      if ($button) {
        // Search
        if ($button.classList.contains('search') || $button.classList.contains('close-search')) {
          toggleSearch();
        }
        // Menu
        else if ($button.classList.contains('menu')) {
          toggleMenu();
        }
        // Panel toggle
        else if ($button.classList.contains('panel-toggle')) {
          const $section = $button.closest('.section');
          $section && $section.classList.add('open');
          $navFooter && $navFooter.classList.add('open');
          const buttons = navigation.querySelectorAll('.hamburger .section .panel-toggle');
          Array.prototype.forEach.call(buttons, (b) => {
            b.style.display = 'none';
          });
        }
        // Panel back
        else if ($button.classList.contains('panel-back')) {
          const $section = $button.closest('.section');
          $section && $section.classList.remove('open');
          $navFooter && $navFooter.classList.remove('open');
          const buttons = navigation.querySelectorAll('.hamburger .section .panel-toggle');
          Array.prototype.forEach.call(buttons, (b) => {
            b.style.display = 'flex';
          });
        }
      }
    }
  });

  // Handle scroll on the UI for homepage.
  let $logo = document.querySelector('#homepage-v2 .home-header .logo');
  if (!$logo) {
    $logo = document.querySelector('#homepage-data-breach-header-v1 .logo svg');
  }
  const $navigation = document.querySelector('header.navigation');
  if ($logo) {
    EventPubSub.subscribe(SCROLL, () => {
      if (isElementInView($logo, false, -50)) {
        $navigation.classList.add('homepage-logo-visible');
      }
      else {
        $navigation.classList.remove('homepage-logo-visible');
      }
    });
    if (isElementInView($logo, false, -50)) {
      $navigation.classList.add('homepage-logo-visible');
    }
    else {
      $navigation.classList.remove('homepage-logo-visible');
    }
  }

  // Prevent flashes of animation on page load.
  setTimeout(() =>
    {
      try {
        document.querySelector('header.navigation nav.main, header.navigation nav.menu').classList.add('can-animate');
      } catch(err) {}
    }, 0);

  let showHideDropdownMaskTimeout = null;
  function showHideDropdownMask(elLi) {
    const elDropdown = elLi.querySelector('.dropdown');
    const elMask = elLi.querySelector('.dropdown-mask');
    if (!elMask) return;
    if (elDropdown.scrollHeight - elDropdown.scrollTop - elDropdown.clientHeight < 20 ) {
      if (!showHideDropdownMaskTimeout) {
        elMask.style.opacity = '0';
        showHideDropdownMaskTimeout = setTimeout(() => {
          elMask.style.zIndex = '-1';
          showHideDropdownMaskTimeout = null;
        }, 300);
      }
    } else if (elDropdown.scrollHeight - elDropdown.scrollTop - elDropdown.clientHeight > 30) {
      if (showHideDropdownMaskTimeout) {
        clearTimeout(showHideDropdownMaskTimeout);
        showHideDropdownMaskTimeout = null;
        elMask.style.zIndex = '';
        elMask.style.opacity = '';
      }
    }
  }

  // Add hover & click effect to main nav
  var elHeaderNav = document.querySelector('header.navigation');
  if( elHeaderNav ){
    var elMainNav = elHeaderNav.querySelector('header.navigation nav.main');
    var elMainNavSection = elMainNav.querySelector('ul.sections');
    var elsMainNavSectionLis = Array.prototype.slice.call( elMainNav.querySelectorAll('ul.sections > li.section') );
    var delay = 200;
    window.addEventListener( 'load', function() {
      elsMainNavSectionLis.map( function(elLi,idx){
        let mouseIn = false;
        elLi.addEventListener( 'mouseenter', function(){
          mouseIn = true;
          window.setTimeout( function(){
            if( !mouseIn ) return;
            if( !elLi.classList.contains('pinned') ){
              elsMainNavSectionLis.map( function( elLiCur ){
                if( elLiCur === elLi ){
                  const elDropdown = elLiCur.querySelector('.dropdown');
                  let elMask = elLiCur.querySelector('.dropdown-mask');
                  elDropdown.style.left = `${elLiCur.clientWidth / 2 + elLiCur.offsetLeft}px`;
                  elLiCur.classList.add('hover');
                  if (!elMask) {
                    if (elDropdown.clientHeight < elDropdown.scrollHeight) {
                      elMask = document.createElement('div');
                      elMask.classList.add('dropdown-mask');
                      elMask.style.left = `${elLiCur.clientWidth / 2 + elLiCur.offsetLeft}px`;
                      elLiCur.append(elMask);
                      showHideDropdownMask(elLi);
                    }
                  }
                }else{
                  elLiCur.classList.remove('hover');
                }
                elLiCur.classList.remove('pinned');
                elLiCur.classList.remove('pinned-off');
              } );
              elHeaderNav.classList.add('in-hover');
              elHeaderNav.classList.remove('in-pinned');
            }
          }, delay );
        } );

        elLi.addEventListener( 'mouseleave', function(){
          mouseIn = false;
          window.setTimeout( function(){
            if( mouseIn ) return;
            elLi.classList.remove('hover');
            elHeaderNav.classList.remove('in-hover');
          }, delay);
        } );

        elLi.querySelector('.dropdown').addEventListener('scroll', function(e) {
          showHideDropdownMask(elLi);
        });

        var elBtn = elLi.querySelector('button');

        elBtn.addEventListener( 'click', function(){
          if( elLi.classList.contains('pinned') ){
            elLi.classList.remove('pinned');
            elLi.classList.add('pinned-off');
            elHeaderNav.classList.remove('in-pinned');
          }else{
            elLi.classList.add('pinned');
            elLi.classList.remove('pinned-off');
            elHeaderNav.classList.add('in-pinned');
          }
        } );

      } );
    });

    document.addEventListener( 'click', function( event ){
      var elClosest = event.target.closest( 'header.navigation nav.main ul.sections > li.section' );
      if( !elClosest ){
        elHeaderNav.classList.remove('in-pinned');
        elsMainNavSectionLis.map( function( elLiCur ){
          elLiCur.classList.remove('pinned');
          elLiCur.classList.remove('pinned-off');
        } );
      }
    } );

    var elMenuOverlay = elHeaderNav.querySelector('.menu-overlay');
    if ( elMenuOverlay ) {
      elMenuOverlay.addEventListener( 'click', toggleMenu );
    }

  }


}
